import { render, staticRenderFns } from "./BookmarkList.vue?vue&type=template&id=3476e06c&scoped=true"
import script from "./BookmarkList.vue?vue&type=script&lang=js"
export * from "./BookmarkList.vue?vue&type=script&lang=js"
import style0 from "./BookmarkList.vue?vue&type=style&index=0&id=3476e06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476e06c",
  null
  
)

export default component.exports